import { Injectable } from '@angular/core';
import { concatMap } from 'rxjs/operators';
import { LeadAppLinkEntity,LeadAppLinkEntityFromBackend } from '../../../entities/mdqx/leadapp/lead-app-link.entity';
import { AppGatewayService } from '../../../services/app-gateway.service';
import { DaveActions } from '../../actions/actions';
import { Actions, createEffect,ofType } from '@ngrx/effects';
import { LeadAppLinkActionTypes } from '../../actions/mdqx/lead-app-link.actions';
import { LeadAppLinkActivityActionTypes } from '../../actions/mdqx/lead-app-link-activity.action';
import { Store } from '@ngrx/store';
import { State } from '../../index';
import { LeadAppLinkActivityEntityFromBackend } from '../../../entities/mdqx/leadapp/lead-app-link-activity.entity';




const ErrorCodes = {
    Get: LeadAppLinkEntity.EntityName + ' Abrufen der Logs fehlgeschlagen',
};

@Injectable()
export class LeadAppLinkActivityEffects {
    GetLeadAppLinkActivityById$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LeadAppLinkActivityActionTypes.GetLinkActivityRequestById),
            concatMap(({ Payload }) =>
                this.gatewayService
                    .Request({
                        LeadAppLinkActivity: {
                            LinkId: Payload,
                        },
                    })
                    .then((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            return LeadAppLinkActivityActionTypes.GetSuccess({
                                Payload: res.LeadAppLinkActivity.LinkActivities.map((link) => LeadAppLinkActivityEntityFromBackend(link)),
                            });
                        } else {
                            throw res.Errors;
                        }
                    })
                    .catch((err) => {
                        return LeadAppLinkActivityActionTypes.GetFailure({
                            Payload: {
                                ToasterMessage: ErrorCodes.Get,
                                Errors: err,
                            },
                        });
                    }),
            ),
        );
    });
    constructor(private actions$: Actions<DaveActions>, private store$: Store<State>, private gatewayService: AppGatewayService) {}
}
